import { Stack } from "@mantine/core";
import { useEffect, useState } from "react";
import "./SidePanel.css";

const SidePanel: React.FC<{
  onClick?: (arg) => void;
  collapsed?: boolean;
  children: JSX.Element | JSX.Element[];
}> = ({ onClick, collapsed = false, children }) => {
  const [rendered, setRendered] = useState(!collapsed);
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    if (!collapsed) {
      setRendered(true);
      setAnimationClass("offscreen");
      requestAnimationFrame(() => {
        setAnimationClass("slideIn");
      });
    } else {
      setAnimationClass("slideOut");
    }
  }, [collapsed]);

  const handleAnimationEnd = () => {
    if (collapsed) {
      setRendered(false);
    }
    setAnimationClass("");
  };

  return (
    <>
      {rendered === true && (
        <Stack
          h="100%"
          pt="65px"
          gap={0}
          className={`notificationSidebar ${animationClass}`}
          onAnimationEnd={handleAnimationEnd}
          onClick={onClick}
        >
          {children}
        </Stack>
      )}
    </>
  );
};

export default SidePanel;
